/** Shared timing for battlefield reposition fly animations (Raid, Phase Traverse, etc.). */
export const REPOSITION_MOVE_DURATION_MS = 1000;
export const REPOSITION_HIDE_BUFFER_MS = 150;
export const REPOSITION_TOTAL_MS = REPOSITION_MOVE_DURATION_MS + REPOSITION_HIDE_BUFFER_MS;
